import { render, staticRenderFns } from "./SignaturesManager.vue?vue&type=template&id=33cc412b&scoped=true&"
import script from "./SignaturesManager.vue?vue&type=script&lang=js&"
export * from "./SignaturesManager.vue?vue&type=script&lang=js&"
import style0 from "./SignaturesManager.vue?vue&type=style&index=0&id=33cc412b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc412b",
  null
  
)

export default component.exports